import { render, staticRenderFns } from "./BranchDeliveryCostsRow.vue?vue&type=template&id=39939522&scoped=true&"
import script from "./BranchDeliveryCostsRow.vue?vue&type=script&lang=js&"
export * from "./BranchDeliveryCostsRow.vue?vue&type=script&lang=js&"
import style0 from "./BranchDeliveryCostsRow.vue?vue&type=style&index=0&id=39939522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39939522",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextField,VTextarea})
